/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menucompanyprofile2Inputs */

const en_menucompanyprofile2 = /** @type {(inputs: Menucompanyprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Profile`)
};

const de_menucompanyprofile2 = /** @type {(inputs: Menucompanyprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil`)
};

/**
* | output |
* | --- |
* | "Company Profile" |
*
* @param {Menucompanyprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menucompanyprofile2 = /** @type {((inputs?: Menucompanyprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menucompanyprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_menucompanyprofile2(inputs)
	return en_menucompanyprofile2(inputs)
});
export { menucompanyprofile2 as "menuCompanyProfile" }